import { createContext } from 'react';
import type { PresenceContextProps } from '../Presence.types';

const defaultContextValue: PresenceContextProps = {
  socket: null,
  isConnected: false,
  currentUserId: null,
};

const PresenceContext = createContext<PresenceContextProps>(defaultContextValue);

export default PresenceContext;
